// --- API Hooks ---
import { useGetOrderDetailsQuery } from "../templates/ecommerce/order/api/orderApi";

// --- Components ---
import OrderPage from "../templates/ecommerce/order/components/OrderPage";
import OrderHeader from "../templates/ecommerce/order/components/OrderHeader";
import OrderSummary from "../templates/ecommerce/order/components/OrderSummary";
import OrderTotals from "../templates/ecommerce/order/components/OrderTotals";
import OrderItemsSummary from "../templates/ecommerce/order/components/OrderItemsSummary";
import OrderAddressCard from "../templates/ecommerce/order/components/OrderAddressCard";
import OrderBacsDetails from "../templates/ecommerce/order/components/OrderBacsDetails";
import OrderAgreementsSnapshot from "../templates/ecommerce/order/components/OrderAgreementsSnapshot";
import CustomerNoteDisplay from "../templates/ecommerce/order/components/CustomerNoteDisplay";

// --- Logic Helpers (Analytics & Processing) ---
import { trackPurchase } from "../templates/ecommerce/order/helpers/trackPurchase";
import { useOrderProcessing } from "../templates/ecommerce/order/hooks/useOrderProcessing";

export const order = {
  // 1. API Hooks
  api: {
    useGetOrderDetailsQuery,
  },

  // 2. Logic & Analytics
  logic: {
    useOrderProcessing,
    trackPurchase,
  },

  // 3. UI Components (Allows theme to re-compose the order view)
  components: {
    OrderPage,
    OrderHeader,
    OrderSummary,
    OrderTotals,
    OrderItemsSummary,
    OrderAddressCard,
    OrderBacsDetails,
    OrderAgreementsSnapshot,
    CustomerNoteDisplay,
  },
};
